// Coxa Generic Phrases related constants
export const COXA_GENERIC_PHRASE_TYPE = "coxa";
export const COXA_GENERIC_APPOINTMENT_SEGMENT_PHRASE_KEYWORD = "aika";
export const COXA_GENERIC_CAREUNIT_SEGMENT_PHRASE_KEYWORD = "tiedustelut";

// Generic Phrases related constants
export const COMMON_GENERIC_PHRASE_TYPE = "common";